import React from 'react';
import { Dialog, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';

const FullPageSpinner = ({ isVisible }) => {
  return (
    <Dialog
      open={isVisible}
      fullWidth
      maxWidth="xs"
      // TODO need layoutApi to have func for closing fullpagespinner
      // onClose={(event, reason) => {
      //   if (reason === 'escapeKeyDown' || reason === 'backdropClick') {

      //   }
      // }}
    >
      <div style={{ textAlign: 'center', padding: '2em 0' }}>
        <CircularProgress />
      </div>
    </Dialog>
  );
};

FullPageSpinner.propTypes = {
  isVisible: PropTypes.bool.isRequired
};

export default FullPageSpinner;
